import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

function MensualidadesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_MENSUALIDADES = process.env.REACT_APP_URL_MENSUALIDADES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const [text, setText] = useState(false);

  const [cliente, setCliente] = useState([]);
  const [fecha_inicio, setFechaInicio] = useState("");
  const [frecuencia, setFrecuencia] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [importe_actual, setImporteActual] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [value, setValue] = useState('');
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setCliente([]);
    setFechaInicio("");
    setDescripcion("");
    setImporteActual("");
    setFrecuencia('');
    setSelectedCliente("");
    setValidaBoton(true)
  };

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setCliente(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveMensualidad = (event) => {
    event.preventDefault();
    setValidaBoton(false)
    axios
      .post(
        URL_MENSUALIDADES,
        {
          fecha_inicio,
          frecuencia,
          descripcion,
          importe_actual,
          importe_anterior:0,
          ultimo_aumento:fecha_inicio,
          clientes: value._id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Crear Mensualidad',
            detalle: `${value._id}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  };

  const options = cliente.map((option) => {
    const junta = option.nombre_comercial
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option, junta
    };
  })

  return (
    <>
      <Header />
      <br />
      {user.usuarios_permisos  ?(
      <div className="container">
        <div className="card container col-sm-8">
          <h3 align="center">Crea una Mensualidad</h3>
          <Form onSubmit={saveMensualidad}>
          <Row>
            <Col md={6}>
            <Label className="mr-sm-2">Cliente</Label>
            <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      setValue(selectedCliente);
                    }}
                    options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                    renderOption={(option) => (
                      <React.Fragment>
                    {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
            </Col>
            <Col md={6}>
            <Label for="exampleEmail" className="mr-sm-12">
                    Frecuencia
                  </Label>
                  <Input
                    type="select"
                    placeholder="Frecuencia"
                    value={frecuencia}
                    required
                    onChange={(e) => {
                      setFrecuencia(e.target.value);
                    }}
                  >
                    <option value="0">Frecuencia</option>
                    <option value="Mensual">Mensual</option>
                    <option value="Anual">Anual</option>
                  </Input>
            </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label>Importe</Label>
                <Input
                  className="col-sm-12"
                  type="number"
                  placeholder="Importe"
                  value={importe_actual}
                  required
                  onChange={(e) => {
                    setImporteActual(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label>Fecha Inicio</Label>
                <Input
                  type="date"
                  value={fecha_inicio}
                  required
                  onChange={(e) => {
                    setFechaInicio(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Label className="mr-sm-2">Descripcion</Label>
            <Input
              className="col-sm-12"
              type="text"
              placeholder="Descripcion"
              value={descripcion}
              required
              onChange={(e) => {
                setDescripcion(e.target.value);
              }}
            />
           
            <Row>
            {validaBoton ? (
        <Button type="submit" className="btn btn-success">
        Registrar
      </Button>
      ):(
      <Button type="submit" className="btn btn-success" disabled>
        Registrar
      </Button>)}
              <div>
                <SweetAlert
                  show={text}
                  title="Creado con Exito"
                  // text="SweetAlert in React"
                  onConfirm={() => {
                    setText(false);
                  }}
                />
              </div>
              <Button
                // Editar Ruta
                href="/ListadoMensualidades"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
        </div>
      </div>
      ): undefined } 
    </>
  );
}

export default MensualidadesCreate;
